import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withMultiFileUploader } from '../../../app/hoc/withMultiFileUploader';
import { LOADER_CLOSE, LOADER_OPEN } from '../../../app/redux/actions';
import { apiHost, baseUrl } from '../../../app/api/config';
import {
  COURSE_SAVING,
  FILE_UPLOADED,
} from '../../../app/redux/actions/tutors';

const DocumentsUploader = ({
  format,
  loaderOpen,
  loaderClose,
  onFileLoad,
  documents,
  courseCreation,
  onFileUpload,
  setFlowEnd,
}) => {
  useEffect(() => {
    if (courseCreation?.loading === 1) {
      const docsObject = {};
      (documents || []).forEach((d, i) => {
        docsObject[`document_${i}`] = d;
      });
      uploadFiles({
        id: courseCreation?.courseId,
        keys: Object.keys(docsObject),
        files: docsObject,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseCreation, documents]);

  const onFlowCompleted = (err) => {
    onFileUpload(err);
    setFlowEnd();
  };

  const uploadFiles = ({ id, files, keys }) => {
    if (!files || Object.keys(files)?.length <= 0) {
      onFlowCompleted();
      return;
    }
    loaderOpen();
    const filesToUpload = files;
    const fileToRead = Object.values(files)[0];
    const reader = new FileReader();

    reader.onabort = (evt) => {
      // eslint-disable-next-line no-console
      console.log('FileUpload > reader.onabort', evt);
    };
    reader.onerror = (err) => {
      // eslint-disable-next-line no-console
      console.log('FileUpload > reader.onerror', err);
    };
    reader.onload = (e) => {
      onFileLoad(
        keys,
        filesToUpload,
        `${apiHost}${baseUrl}pzzl_document/node/${id}/inner/document/upload`,
        () => onFlowCompleted(),
        () => loaderClose(),
        () => onFlowCompleted('documents') // onError
      );
    };
    if (!filesToUpload) loaderClose();
    switch (format) {
      case 'BASE64':
        reader.readAsDataURL(fileToRead);
        break;

      case 'BINARY':
      default:
        reader.readAsArrayBuffer(fileToRead);
        break;
    }
  };

  return <div style={{ display: 'none' }}>DocumentsUploader</div>;
};

DocumentsUploader.propTypes = {
  documents: PropTypes.array,
  courseCreation: PropTypes.object,
  onFileUpload: PropTypes.func,

  // HOC: fileUploader
  format: PropTypes.string,
  loaderOpen: PropTypes.func,
  loaderClose: PropTypes.func,
  onFileLoad: PropTypes.func,
  setFlowEnd: PropTypes.func,
};

export default connect(
  (state) => {
    const { courseCreation } = state.tutors;
    return { courseCreation };
  },
  (dispatch) => ({
    loaderOpen: () => dispatch({ type: LOADER_OPEN }),
    loaderClose: () => dispatch({ type: LOADER_CLOSE }),
    onFileUpload: (error) =>
      dispatch({ type: FILE_UPLOADED, loading: 0, error }),
    setFlowEnd: () => dispatch({ type: COURSE_SAVING, saving: false }),
  })
)(withMultiFileUploader(DocumentsUploader));
